import { render } from "./NoticiaDelDia.vue?vue&type=template&id=707db91e&scoped=true"
import script from "./NoticiaDelDia.vue?vue&type=script&lang=js"
export * from "./NoticiaDelDia.vue?vue&type=script&lang=js"

import "./NoticiaDelDia.vue?vue&type=style&index=0&id=707db91e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707db91e"]])

export default __exports__